import React from 'react';
import { m } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { StarRating } from '../ui/StarRating';
import { SectionTag } from '../ui/SectionTag';
import { scrollToId } from '../utils/scroll';
export function Hero() {
  return <header className="relative overflow-hidden bg-bg-primary pb-10 pt-8 sm:pb-12 sm:pt-10" data-id="element-132" data-mp="hv7hddkf0t1u">
      <div className="pointer-events-none absolute -top-40 left-1/2 h-[420px] w-[720px] -translate-x-1/2 rounded-full bg-orange/10 blur-3xl" aria-hidden="true" data-id="element-133" data-mp="muty3wzgcrfe" />
      <div className="relative mx-auto flex max-w-4xl flex-col items-center px-4 text-center sm:px-6" data-id="element-134" data-mp="vmm0rli8iw9f">
        <m.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-135" data-mp="10lypycwkwff6">
          <SectionTag icon="🏀" data-id="element-136" data-mp="15lbcewjjfkh8">Para entrenadores cansados de improvisar cada semana</SectionTag>
        </m.div>

        <m.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="mt-6 font-heading text-4xl font-bold uppercase leading-[1.08] tracking-tight text-white sm:text-5xl md:text-6xl" data-id="element-137" data-mp="1ako5w04wzpss">
          Todo tu año de <span className="text-orange" data-id="element-138" data-mp="3vvj5g80hhoql">Baloncesto</span> resuelto.
        </m.h1>

        {/* Plain img (no entrance animation) — this is the LCP element, so it must
            paint the instant it downloads instead of waiting on a JS-driven fade/scale.
            loading="eager" + fetchPriority="high" make it the single highest-priority,
            non-lazy image on the page; width/height reserve its box to avoid CLS. */}
        <img src="https://cdn.magicpatterns.com/uploads/3N5jf9ehdBxKLaEMBRrQ3G/ChatGPT_Image_30_jul_2026__12_35_32-removebg-preview.png" alt="El Manual del Entrenador de Baloncesto: colección de 6 tomos, 5 bonos y kit de implementación con balón y accesorios" width={640} height={620} loading="eager" fetchPriority="high" decoding="async" className="mt-8 w-full max-w-md sm:max-w-lg" data-id="element-139" data-mp="im4nfr5cp15l" />

        <m.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="mt-6 max-w-2xl text-base leading-relaxed text-muted sm:text-lg" data-id="element-140" data-mp="35kh48nonaave">
          <span className="font-semibold text-white" data-id="element-141" data-mp="2hvpgq9m02goy">EL MANUAL DEL ENTRENADOR DE BALONCESTO</span> — el
          sistema "Sesión en Mano" con 6 tomos, más de 180 sesiones completas y 5 bonos exclusivos. Incluye
          ahora el <span className="font-semibold text-white" data-id="element-142" data-mp="27y1mdksb3b7b">KIT DE IMPLEMENTACIÓN TOTAL</span>. Sin
          improvisar. Sin sacrificar tus domingos.
        </m.p>

        <m.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.28
      }} className="mt-8" data-id="element-143" data-mp="2cy62h9pay3x0">
          <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-144" data-mp="b2vokruh0kus">
            ¡Sí, quiero el Manual Completo!
          </PrimaryButton>
        </m.div>

        <m.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.35
      }} className="mt-6 flex flex-col items-center gap-2 text-sm text-muted sm:flex-row sm:gap-4" data-id="element-145" data-mp="1qopbf2ym4q8b">
          <div className="flex items-center gap-2" data-id="element-146" data-mp="20k0s3qtl07ip">
            <StarRating data-id="element-147" data-mp="2ecgwow24sdlq" />
            <span className="font-medium text-white" data-id="element-148" data-mp="2ebozjgsvy7tc">4.9/5</span>
            <span data-id="element-149" data-mp="2acojg61slja1">· +500 reseñas verificadas</span>
          </div>
          <div className="hidden h-4 w-px bg-white/15 sm:block" aria-hidden="true" data-id="element-150" data-mp="2obo7pcle7w5o" />
          <div className="flex items-center gap-1.5 text-orange" data-id="element-151" data-mp="2o9lhosk8q30y">
            <FlameIcon size={16} className="fill-orange" data-id="element-152" data-mp="2jdwgylwhig32" />
            <span data-id="element-153" data-mp="txevkypt61tv">38 entrenadores eligieron este Manual hoy</span>
          </div>
        </m.div>
      </div>
    </header>;
}